import { useCallback } from 'react'

import { isAnalyticsFrameForeground } from 'shared/services/analytics/navigation/analyticsFrames'

import { AnalyticsMeasurementTracker } from '../AnalyticsMeasurementTracker/AnalyticsMeasurementTracker'
import { ANALYTICS_TRACKING_SOURCE } from '../AnalyticsTracker.constants'
import {
  canTrackAnalyticsPage,
  isAuthAnalyticsPath
} from '../AnalyticsTracker.utils'
import { useAuthViewIdentity } from '../useAuthViewIdentity'
import type { FrameTrackerProps } from './FrameTracker.types'

export const FrameTracker = ({
  frame,
  enabled,
  context
}: FrameTrackerProps) => {
  const foreground = useCallback(
    () => isAnalyticsFrameForeground(frame.iframe),
    [frame.iframe]
  )
  const route = frame.route
  const identity = useAuthViewIdentity(
    enabled && route && isAuthAnalyticsPath(route.pathname)
      ? `${route.revision}:${route.path}`
      : null,
    context
  )
  const canTrack =
    route && canTrackAnalyticsPage({ pathname: route.pathname, ...context })
  return (
    <AnalyticsMeasurementTracker
      enabled={enabled}
      view={
        canTrack && route
          ? {
              ...identity,
              path: route.path,
              appPath: route.path,
              appId: frame.appId,
              appName: frame.title,
              title: frame.title,
              pageLocation: route.location,
              pageReferrer: route.referrer,
              trackingSource: ANALYTICS_TRACKING_SOURCE
            }
          : null
      }
      checkpointScope={`::frame:${frame.id}`}
      foreground={foreground}
      activityVersion={frame.activityVersion}
      viewVersion={route?.revision}
    />
  )
}
